<template>
  <div class="main-container">
    <router-view></router-view>
    <!-- Navbar section -->
    <HeaderSoftware />

    <!-- hero section -->
        <!-- <HeroClinic /> -->
        <!-- breadcrumb strat -->
        <Breadcrumb>
            <template slot="breadcrumb">
                <div class="breadcrumb_box text-center">
                    <h2 class="breadcrumb-title">{{$t('efatura')}}</h2>
                    <!-- breadcrumb-list start -->
                    <ul class="breadcrumb-list">
                        <li class="breadcrumb-item"><router-link :to="{name:'HomeBranding'}">{{$t('home')}}</router-link></li>
                        <li class="breadcrumb-item active">{{$t('efatura')}}</li>
                    </ul>
                    <!-- breadcrumb-list end -->
                </div>
            </template>
        </Breadcrumb>
        <!-- breadcrumb end -->

        <div class="tabs-wrapper section-space--pt_120 section-space--pb_60 bg-gradient" >
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <slick class="slick1 tab-slider-nav"
                        :options="slickOptions">
                            <div class="tab-slider-nav--list wow move-up">
                                <i class="ht-slider-tab-icon fal fa-file-invoice"></i>
                                <h5>{{ $t('efatura') }}</h5>
                                <p>{{ $t('efaturaaciklama') }}</p>
                            </div>
                            <div class="tab-slider-nav--list wow move-up">
                                <i class="ht-slider-tab-icon fal fa-receipt"></i>
                                <h5>{{ $t('earsiv') }}</h5>
                                <p>{{$t('earsivaciklama')}} </p>
                            </div>
                            <div class="tab-slider-nav--list wow move-up">
                                <i class="ht-slider-tab-icon fal fa-file-alt"></i>
                                <h5>{{ $t('eirsaliye') }}</h5>
                                <p>{{$t('eirsaliyeaciklama')}}</p>
                            </div>
                    </slick>
                </div>
                <div class="col-lg-8">
                    <slick class="slick2"
                        :options="slickOptions2">
                            <div class="pro-large-img img-zoom wow move-up">
                                <img class="img-fluid" src="../assets/img/banners/KarpinEfatura.webp" alt="eFatura-details" loading="lazy"/>
                            </div>
                            <div class="pro-large-img img-zoom wow move-up">
                                <img class="img-fluid" src="../assets/img/banners/KarpinPos.webp" alt="pos-details" loading="lazy"/>
                            </div>
                            <div class="pro-large-img img-zoom wow move-up">
                                <img class="img-fluid" src="../assets/img/banners/KarpinErp.webp" alt="erp-details" loading="lazy"/>
                            </div> 
                    </slick>
                </div>
            </div>
        </div>
    </div>

    
    <!-- gradation component start -->
    <div class="icon-process-area section-space--ptb_120">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="icon-process-wrapper">
              <div class="icon-process-single wow move-up">
                <div class="icon-process-single__line">
                  <div class="dot dot-1"></div>
                  <div class="dot dot-2"></div>
                  <div class="dot dot-3"></div>
                  <div class="dot dot-4"></div>
                  <div class="dot dot-3"></div>
                  <div class="dot dot-2"></div>
                  <div class="dot dot-1"></div>
                </div>
                <div class="icon-process-single__content-wrap">
                  <div class="icon-process-single__media">
                    <i class="fa fa-watch"></i>
                  </div>
                  <h5 class="icon-process-single__title">{{$t('zamantasarrufu')}}</h5>
                  <div class="icon-process-single__text">{{$t('zamantasarrufuaciklama')}}</div>
                </div>
              </div>
              <div class="icon-process-single wow move-up">
                <div class="icon-process-single__line">
                  <div class="dot dot-1"></div>
                  <div class="dot dot-2"></div>
                  <div class="dot dot-3"></div>
                  <div class="dot dot-4"></div>
                  <div class="dot dot-3"></div>
                  <div class="dot dot-2"></div>
                  <div class="dot dot-1"></div>
                </div>
                <div class="icon-process-single__content-wrap">
                  <div class="icon-process-single__media">
                    <i class="fa fa-retweet"></i>
                  </div>
                  <h5 class="icon-process-single__title">{{$t('gecmisverilereulasimkolayligi')}}</h5>
                  <div class="icon-process-single__text">{{$t('gecmisverilereulasimkolayligiaciklama')}}</div>
                </div>
              </div>
              <div class="icon-process-single wow move-up">
                <div class="icon-process-single__line">
                  <div class="dot dot-1"></div>
                  <div class="dot dot-2"></div>
                  <div class="dot dot-3"></div>
                  <div class="dot dot-4"></div>
                  <div class="dot dot-3"></div>
                  <div class="dot dot-2"></div>
                  <div class="dot dot-1"></div>
                </div>
                <div class="icon-process-single__content-wrap">
                  <div class="icon-process-single__media">
                    <i class="fa fa-save"></i>
                  </div>
                  <h5 class="icon-process-single__title">{{$t('kagitsaklamasikintisininsonaermesi')}}</h5>
                  <div class="icon-process-single__text">{{$t('kagitsaklamasikintisininsonaermesiaciklama')}}</div>
                </div>
              </div>
              <div class="icon-process-single wow move-up">
                <div class="icon-process-single__line">
                  <div class="dot dot-1"></div>
                  <div class="dot dot-2"></div>
                  <div class="dot dot-3"></div>
                  <div class="dot dot-4"></div>
                  <div class="dot dot-3"></div>
                  <div class="dot dot-2"></div>
                  <div class="dot dot-1"></div>
                </div>
                <div class="icon-process-single__content-wrap">
                  <div class="icon-process-single__media">
                    <i class="fa fa-sort-amount-down"></i>
                  </div>
                  <h5 class="icon-process-single__title">{{$t('maliyetavantaji')}}</h5>
                  <div class="icon-process-single__text">{{$t('maliyetavantajiaciklama')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

       <!-- brand logo carousel -->
		   <BrandLogoCarousel />
        
        <CtaThree />

        <!-- footer component -->
        <FooterMain class="border-top" />

    <!-- offcanvas search component -->
    <OffcanvasSearchBox />

    <!-- off-canvas mobile menu -->
    <OffCanvasMobileMenu />
  </div>
</template>
<script>
import HeaderSoftware from "../components/HeaderSoftware";
import HeroClinic from '@/components/sections/HeroClinic'
import Breadcrumb from "@/components/Breadcrumb";
import FooterMain from "@/components/FooterMain";
import OffcanvasSearchBox from "@/components/OffcanvasSearchBox";
import OffCanvasMobileMenu from "@/components/OffCanvasMobileMenu";
import BrandLogoCarousel from "../components/BrandLogoCarousel";
import CtaThree from '@/components/CtaThree'
import Slick from 'vue-slick';
export default {
  props: ["BgGradient"],
  components: {
    Slick,
    HeaderSoftware,
    HeroClinic,
    Breadcrumb,
    FooterMain,
    OffcanvasSearchBox,
    OffCanvasMobileMenu,
    BrandLogoCarousel,
            CtaThree
  },
  data() {
            return {
                slickOptions: {
                    slidesToShow: 3,
                    focusOnSelect: true,
                    vertical: true,
                    asNavFor: '.slick2'
                },
                slickOptions2: {
                    arrows: false,
                    fade:true,
                    dots:true,
                    asNavFor: '.slick1'
                }
            };
        }
};
</script>
